import React from 'react'

export default class DataSourceDetails extends React.Component {
  constructor(props) {
    super(props);
  };

  render() {
    return (
      <div className="container">
      <div className="row" >
        <div className="col-md-2">
          <div className="form-group">
            <label>{`${I18n.t('code')}*`}</label>
            {
              this.props.data_source.system_data 
                ?
                <p>{this.props.data_source.code}</p>
                :
                <input type="text" maxLength="12" className='form-control' defaultValue={this.props.data_source.code ? this.props.data_source.code : ''} onChange={e => this.props.onChangeInput(e.target.value, 'code', false)} />
            }
          </div>
        </div>
        <div className="col-md-3">
          <label>{`${I18n.t('name')}*`}</label>
          <div className="form-group">
            {
              this.props.data_source.system_data
                ?
                <p>{I18n.t(this.props.data_source.name)}</p>
                :
                <input className='form-control' defaultValue={this.props.data_source.name ? this.props.data_source.name : ''} onChange={e => this.props.onChangeInput(e.target.value, 'name', false)} />
            }
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group">
            <label>{I18n.t('status')}</label>
            <br />
            <select
              id="status"
              name="room_type[status]"
              value={this.props.data_source.status ? this.props.data_source.status : ''}
              onChange={e => this.props.onChangeInput(e.target.value, 'status', false)}
              className="form-control">
              <option value="enabled">{I18n.t('enabled')}</option>
              <option value="disabled">{I18n.t('Disabled')}</option>
            </select>
          </div>
        </div>
      </div>
      </div>
    );
  };

}